// Super Admin client for the nightly per-institution export module
// (/super-admin/tenant-export): runs, manifest, zip download, Drive mirror.
import { apiGet, apiPost, apiFetch } from '@/utils/api';
import type { BackupOverview, DriveStatus, DriveSyncResult, TenantExportManifest, TenantExportRun } from '@/types/tenant-export.types';

const BASE = '/super-admin/tenant-export';

export const tenantExportService = {
  listRuns: (tenantId?: string, limit = 60): Promise<TenantExportRun[]> => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (tenantId) params.set('tenantId', tenantId);
    return apiGet(`${BASE}/runs?${params.toString()}`);
  },

  startRun: (tenantId: string): Promise<{ jobId: string }> => apiPost(`${BASE}/${tenantId}/run`),

  startRunAll: (): Promise<{ tenantIds: string[] }> => apiPost(`${BASE}/run-all`),

  getManifest: (jobId: string): Promise<TenantExportManifest> => apiGet(`${BASE}/runs/${jobId}/manifest`),

  driveStatus: (): Promise<DriveStatus> => apiGet(`${BASE}/drive/status`),

  overview: (): Promise<BackupOverview> => apiGet(`${BASE}/overview`),

  syncToDrive: (jobId: string): Promise<DriveSyncResult> => apiPost(`${BASE}/runs/${jobId}/drive-sync`),

  /** Streams the run's workbooks (zip) to the browser as a download. */
  downloadZip: async (jobId: string, fallbackName: string): Promise<void> => {
    const response = await apiFetch(`${BASE}/runs/${jobId}/download`);
    if (!response.ok) throw new Error(`Téléchargement impossible (${response.status})`);
    const disposition = response.headers.get('Content-Disposition') ?? '';
    const match = /filename="?([^";]+)"?/.exec(disposition);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = match?.[1] ?? fallbackName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};
